import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    社区导航: [
      { label: '首页', to: '/' },
      { label: '话题分类', to: '/categories' },
      { label: '热门文章', to: '/categories' },
      { label: '关于我们', to: '/about' },
    ],
    内容板块: [
      { label: '生活分享', to: '/category/life' },
      { label: '情感交流', to: '/category/emotion' },
      { label: '旅行探索', to: '/category/travel' },
      { label: '美食天地', to: '/category/food' },
    ],
    更多板块: [
      { label: '科技数码', to: '/category/tech' },
      { label: '读书学习', to: '/category/reading' },
      { label: '摄影艺术', to: '/category/photography' },
      { label: '运动健康', to: '/category/sports' },
    ],
  };

  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-compass-3-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">海角社区</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              连接你我的温暖交流平台。<br />
              分享生活,交流情感,结交朋友。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-base font-semibold text-background-200 mb-4">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-500">
            &copy; 2026 海角社区. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer whitespace-nowrap">社区规范</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer whitespace-nowrap">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}